import React from 'react';
import PropTypes from 'prop-types';

import { CHECKBOX } from 'helpers/forms/menuItem';
import VariantInputGroup from 'bento-ordering/base/components/VariantInputGroup';

/**
 * This is variant component that needs to be used
 * as a component prop in redux-form.
 */
const VariantInputGroupField = ({
  title,
  input,
  fieldType,
  list,
  checked,
  required,
  disabled,
  helperText,
  isSizeSection,
  maxQty,
  minQty,
  hasInvestorDayFeature
}) => {
  const handleChange = (input, fieldType, event) => {
    const value = fieldType === CHECKBOX ? event : event.target.value;
    input.onChange(value);
  };

  return (
    <VariantInputGroup
      title={title}
      helperText={helperText}
      fieldType={fieldType}
      onChange={event => handleChange(input, fieldType, event)}
      value={input.value || {}}
      list={list}
      checked={checked}
      required={required}
      disabled={disabled}
      isSizeSection={isSizeSection}
      maxQty={maxQty}
      minQty={minQty}
      hasInvestorDayFeature={hasInvestorDayFeature}
    />
  );
};

VariantInputGroupField.propTypes = {
  title: PropTypes.string,
  input: PropTypes.object,
  fieldType: PropTypes.string,
  list: PropTypes.array,
  checked: PropTypes.bool,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  helperText: PropTypes.string,
  isSizeSection: PropTypes.bool,
  maxQty: PropTypes.number,
  minQty: PropTypes.number,
  hasInvestorDayFeature: PropTypes.bool
};

VariantInputGroupField.defaultProps = {
  isSizeSection: false
};

export default VariantInputGroupField;
